// 导入Vue和VueRouter的包
// router/index.js文件
import Vue from 'vue'
import VueRouter from 'vue-router'
 
// 调用Vue.use()函数，把VueRouter安装为Vue的插件
Vue.use(VueRouter)
 
const Home = () => import("../pages/home/home.vue");
const Login = () => import("../pages/login/login.vue");
const FormList = () => import("../pages/taxationFormList/taxationFormList.vue");
const Index = () => import("../pages/index/index.vue");
const Official = () => import("../pages/official/official.vue");
const Updata = () => import("../pages/updata/updata.vue");
const TaxationTag = () => import("../pages/taxationTag/taxationTag.vue");
const DyTaxationFormList = () => import("../pages/dyTaxationFormList/dyTaxationFormList.vue");

// 创建路由的实例对象
const router = new VueRouter({
	mode: 'history',
    routes:[
        {path: '/',redirect: '/official'},
        {path: '/home',component: Home},
		{path: '/login',component: Login},
		{path: '/taxationFormList',component: FormList},
		{path: '/index',component: Index},
		{path: '/official',component: Official},
		{path: '/updata',component: Updata},
		{path: '/taxationTag',component: TaxationTag},
		{path: '/dyTaxationFormList',component: DyTaxationFormList},
    ],
})
 
 
// 导出的目的是为了在main.js进行导入, 将路由实例对象挂载在 new Vue()里面
export default router